<template>
  <div class="td-clear">
    <el-button @click="btnClear">清除缓存</el-button>
    <el-button @click="btnTo">进入添丁</el-button>
  </div>
</template>

<script>
export default {
  name: "TianDingClearComponent",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    btnClear() {
      this.local$.clear();
      this.cookies$.remove("tdCookie");
    },
    btnTo() {
      window.location.href = "/";
    }
  }
};
</script>

<style lang="scss" scoped>
.td-clear {
  text-align: center;
  button {
    margin-top: 100px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/clear.vue